<template>
  <!--begin::User Listing-->
  <ListingTemplate
    :customClass="'user-listing'"
    v-if="getPermission('user:view')"
  >
    <template v-slot:body>
      <ListingHeader>
        <template v-slot:content>
          <template v-if="selectedRows.length > 0">
            <v-col cols="4" class="pt-0">
              <h1 class="form-title d-flex margin-auto selected-rows-text">
                {{ totalSelected }} Selected
              </h1>
            </v-col>
            <v-col cols="8" class="pt-0 justify-flex-end d-flex margin-auto">
              <template v-if="getPermission('user:update')">
                <v-menu
                  content-class="custom-menu-list"
                  bottom
                  offset-y
                  transition="slide-y-transition"
                  :close-on-click="true"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="dataLoading"
                      class="mx-2 custom-grey-border custom-bold-button"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark left>mdi-chevron-down</v-icon>Bulk Action
                    </v-btn>
                  </template>
                  <v-list>
                    <template v-for="(more, index) in userMoreAction">
                      <v-list-item
                        link
                        v-on:click="updateMoreAction(more.action)"
                        :key="index"
                      >
                        <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                          <v-icon class="icon-default-blue">{{
                            more.icon
                          }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title
                          class="font-weight-500 font-size-14"
                          >{{ more.title }}</v-list-item-title
                        >
                      </v-list-item>
                    </template>
                  </v-list>
                </v-menu>
              </template>
              <v-btn
                :disabled="dataLoading"
                class="mx-2 custom-grey-border custom-bold-button"
                color="red lighten-1 white--text"
                v-on:click="clearSelections"
              >
                <v-icon dark left>mdi-close</v-icon>Clear Selections
              </v-btn>
            </v-col>
          </template>
          <template v-else>
            <v-col cols="6" class="pt-0">
              <h1 class="form-title d-flex margin-auto">
                <v-select
                  :disabled="dataLoading"
                  :items="statusList"
                  v-model="status"
                  hide-details
                  item-color="cyan"
                  class="pt-0 mt-0 listing-status main-listing-status-filter"
                  item-text="text"
                  item-value="value"
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                      <!-- <v-list-item-subtitle
                        v-text="item.description"
                      ></v-list-item-subtitle> -->
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-chip :color="item.color" :text-color="item.textcolor">
                        <template v-if="item.value == 'all'">{{
                          item.all_users
                        }}</template>
                        <template v-else>{{ item.user_status_count }}</template>
                      </v-chip>
                    </v-list-item-action>
                  </template>
                </v-select>
              </h1>
            </v-col>
            <v-col cols="6" class="pt-0 justify-flex-end d-flex margin-auto">
              <template v-if="getPermission('user:create')">
                <v-btn
                  :disabled="dataLoading"
                  class="mx-2 custom-bold-button"
                  :to="getDefaultRoute('user.create')"
                  color="cyan white--text"
                  depressed
                >
                  <v-icon dark left>mdi-plus</v-icon> Create
                </v-btn>
              </template>
              <v-menu
                max-height="400"
                max-width="250"
                offset-y
                left
                :close-on-content-click="false"
                content-class="white-background"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="dataLoading"
                    class="mx-2 custom-bold-button"
                    v-on:click="exportQuotation"
                    color="cyan white--text"
                    depressed
                  >
                    <v-icon dark left>mdi-database-export</v-icon> Export
                  </v-btn>
                  <v-btn
                    :disabled="dataLoading"
                    class="mx-2 custom-bold-button"
                    color="cyan white--text"
                    v-bind="attrs"
                    v-on="on"
                    depressed
                  >
                    <v-icon dark>mdi-table-edit</v-icon>
                  </v-btn>
                </template>
                <draggable
                  tag="ul"
                  v-model="defaultColDefs"
                  class="draggable-group"
                  handle=".draggable-drag-icon"
                  v-on:change="updateVisible()"
                >
                  <template v-for="cols in defaultColDefs">
                    <li
                      class="draggable-group-item"
                      :key="cols.field"
                      v-if="!cols.checkbox || Number(cols.checkbox) == 0"
                    >
                      <v-checkbox
                        dense
                        v-model="defaultColShow"
                        v-bind:value="cols.field"
                        :label="cols.headerName"
                        :disabled="Number(cols.fixed) || dataLoading"
                        color="cyan"
                        v-on:change="updateVisible()"
                        hide-details
                        class="mt-0 mb-0"
                      ></v-checkbox>
                      <v-icon class="draggable-drag-icon" right color="cyan"
                        >mdi-drag</v-icon
                      >
                    </li>
                  </template>
                </draggable>
              </v-menu>
            </v-col>
          </template>
        </template>
      </ListingHeader>
      <ListingSearchCriteria
        v-if="searchEnabled"
        pageModule="User"
        :basicSearchFields="['display_name']"
        :allowedSearchFields="searchableArray"
      ></ListingSearchCriteria>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow user-listing-height"
        style="position: relative"
      >
        <ListingTable
          :columnCount="columnLength()"
          :dataLoading="dataLoading"
          :rowData="rowData"
        >
          <template v-slot:thead>
            <thead>
              <tr>
                <template v-for="cols in customThead">
                  <th
                    v-if="cols.visible"
                    :key="cols.id"
                    class="simple-table-th"
                    :class="{
                      'checkbox-width-limit': cols.checkbox,
                      'pointer-events-none': lodash.isEmpty(rowData),
                    }"
                  >
                    <template
                      v-if="cols.checkbox && Number(cols.checkbox) == 1"
                    >
                      <v-checkbox
                        dense
                        :disabled="dataLoading"
                        v-model="selectedAll"
                        color="cyan"
                        class="hide-margin"
                        hide-details
                      ></v-checkbox>
                    </template>
                    <template v-else>
                      <div
                        v-if="cols.sortable"
                        class="simple-table-text sortable"
                        v-on:click="
                          !dataLoading
                            ? updateSorting({
                                field: cols.field,
                                sort: cols.sort,
                              })
                            : 'javascript:void(0)'
                        "
                      >
                        {{ cols.headerName }}
                      </div>
                      <div v-else class="simple-table-text">
                        {{ cols.headerName }}
                      </div>
                      <template v-if="cols.sort">
                        <v-icon
                          class="simple-table-sort"
                          v-if="cols.sort == 'asc'"
                          small
                          right
                          color="cyan"
                          >mdi-sort-ascending</v-icon
                        >
                        <v-icon
                          class="simple-table-sort"
                          v-if="cols.sort == 'desc'"
                          small
                          right
                          color="cyan"
                          >mdi-sort-descending</v-icon
                        >
                      </template>
                    </template>
                  </th>
                </template>
              </tr>
            </thead>
          </template>
          <template v-slot:tbody>
            <tbody class="custom-border-bottom">
              <template v-if="!lodash.isEmpty(rowData)">
                <tr
                  v-for="(data, index) in rowData"
                  :key="index"
                  link
                  class="customer-listing-row"
                  :class="{ 'table-in-active-row': !data.activated }"
                >
                  <template v-for="cols in customThead">
                    <td
                      v-if="cols.visible"
                      :key="cols.id"
                      :class="{
                        'simple-table-td': !cols.checkbox,
                        'checkbox-width-limit': cols.checkbox,
                      }"
                      v-on:click="
                        Number(cols.checkbox) == 0
                          ? rowClicked(data)
                          : 'javascript:void(0)'
                      "
                    >
                      <template
                        v-if="cols.checkbox && Number(cols.checkbox) == 1"
                      >
                        <v-checkbox
                          dense
                          v-model="selectedRows"
                          v-bind:value="data.id"
                          color="cyan"
                          class="hide-margin"
                          hide-details
                        ></v-checkbox>
                      </template>
                      <template v-else-if="cols.field == 'activated'">
                        <div class="user-listing-user">
                          <v-switch
                            v-model="data.activated"
                            class="mt-0"
                            inset
                            v-on:click.prevent.stop="activeInactive(data)"
                            color="green"
                          ></v-switch>
                        </div>
                      </template>
                      <template v-else-if="cols.field == 'image'">
                        <template v-if="data.channel == 'engineer'">
                          <v-img
                            class="customer-image"
                            width="50"
                            height="50"
                            :lazy-src="$defaultProfileImage"
                            :src="getProfileImage(data.engineer_logo)"
                          >
                          </v-img>
                        </template>
                        <template v-else>
                          <v-img
                            class="customer-image"
                            width="50"
                            height="50"
                            :lazy-src="$defaultProfileImage"
                            :src="getProfileImage(data.profile_logo)"
                          >
                          </v-img>
                        </template>
                      </template>

                      <template v-else-if="cols.field == 'user_name'">
                        <div class="user-listing-user">
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Full Name: </b> {{ getFullName(data.full_name) }}
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Display Name: </b> {{ data.display_name }}
                          </p>
                          <!-- <p class="m-0 custom-nowrap-ellipsis">
                            <b>From Amount: </b> {{ data.from_amount }}
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>To Amount: </b> {{ data.to_amount }}
                          </p> -->
                        </div>
                      </template>
                      <template v-else-if="cols.field == 'user_info'">
                        <div class="user-listing-user">
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Phone Number: </b> {{ data.phone_number }}
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Email: </b> {{ data.user_email }}
                          </p>
                          <!-- <p class="m-0 custom-nowrap-ellipsis">
                            <b>From Amount: </b> {{ data.from_amount }}
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>To Amount: </b> {{ data.to_amount }}
                          </p> -->
                        </div>
                      </template>

                      <template v-else-if="cols.field == 'login_detail'">
                        <div
                          class="user-listing-user"
                          v-if="data?.login_detail"
                        >
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Device: </b>
                            <template v-if="data?.login_detail?.device">{{
                              data?.login_detail?.device
                            }}</template>
                            <em v-else class="text-muted"> no device</em>
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Platform: </b>
                            <template v-if="data?.login_detail?.platform">{{
                              data?.login_detail?.platform
                            }}</template>
                            <em v-else class="text-muted"> no platform</em>
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Browser: </b>
                            <template v-if="data?.login_detail?.browser">
                              {{ data?.login_detail?.browser }}</template
                            >
                            <em v-else class="text-muted"> no browser</em>
                          </p>
                        </div>
                        <em v-else class="text-muted"> no login details</em>
                      </template>
                      <template v-else-if="cols.field == 'last_login'">
                        <div
                          class="user-listing-user"
                          v-if="data?.login_detail"
                        >
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>IP Address: </b>
                            <template v-if="data?.login_detail?.ip_address">
                              {{ data?.login_detail?.ip_address }}</template
                            >
                            <em v-else class="text-muted"> no IP Address</em>
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Date: </b>
                            <template v-if="data?.login_detail?.datetime">
                              {{
                                formatDateTime(data?.login_detail?.datetime)
                              }}</template
                            >
                            <em v-else class="text-muted"> no Date time</em>
                          </p>
                        </div>
                        <em v-else class="text-muted"> no login details</em>
                      </template>
                      <template v-else-if="cols.field == 'role'">
                        <div class="user-listing-role">
                          <p
                            class="m-0 custom-nowrap-ellipsis text-uppercase"
                            v-if="data.role"
                          >
                            <v-chip
                              small
                              class="ma-2"
                              color="deep-purple accent-4"
                              label
                              outlined
                            >
                              {{ data.role.name }}
                            </v-chip>
                          </p>
                        </div>
                      </template>
                      <template v-else-if="cols.field == 'other_detail'">
                        <div class="user-listing-role">
                          <p
                            class="m-0 custom-nowrap-ellipsis text-uppercase"
                            v-if="data.role"
                          >
                            <v-chip
                              small
                              class="ma-2"
                              color="blue accent-4"
                              label
                              outlined
                            >
                              <!-- {{ data.role.name }} -->
                              Enable
                            </v-chip>
                          </p>
                        </div></template
                      >
                      <template v-else-if="cols.field == 'added_at'">
                        <TableActivity
                          v-if="!lodash.isEmpty(data.added_by)"
                          :data="data"
                        >
                          <template v-slot:display_name>
                            {{ data.added_by.display_name }}
                          </template>
                          <template v-slot:date_time>
                            <template v-if="getDateCountAll(data.added_at)">{{
                              data.created_at
                            }}</template>
                            <template v-else>{{
                              formatDateTime(data.added_at)
                            }}</template>
                          </template>
                          <template v-slot:format_date_time>
                            {{ formatDateTime(data.added_at) }}
                          </template>
                        </TableActivity>
                      </template>
                      <template v-else-if="cols.field == 'updated_at'">
                        <TableActivity
                          v-if="!lodash.isEmpty(data.updated_by)"
                          :data="data"
                        >
                          <template v-slot:display_name>
                            {{ data.updated_by.display_name }}
                          </template>
                          <template v-slot:date_time>
                            {{ data.modified_at }}
                          </template>
                          <template v-slot:format_date_time>
                            {{ formatDateTime(data.updated_at) }}
                          </template>
                        </TableActivity>
                      </template>
                      <template v-else>
                        <div v-html="printRowData(cols, data)"></div>
                      </template>
                    </td>
                  </template>
                </tr>
              </template>
              <tr v-else-if="!dataLoading">
                <td colspan="6" class="py-4">
                  <p
                    class="m-0 row-not-found text-center font-weight-500 font-size-16"
                  >
                    <img
                      :src="$assetURL('media/error/empty.png')"
                      class="row-not-found-image"
                    />
                    Uhh... There are no user at the moment.
                  </p>
                </td>
              </tr>
            </tbody>
          </template>
        </ListingTable>
      </perfect-scrollbar>
      <ListingFooter
        :dataLoading="dataLoading"
        :showingFrom="showingFrom"
        :showingTo="showingTo"
        :totalRows="totalRows"
        :currentPage="currentPage"
        :totalPages="totalPages"
      ></ListingFooter>
      <DeleteDialog :delete-dialog="deleteInvoiceDialog">
        <template v-slot:title>Delete Confirmation</template>
        <template v-slot:text>
          <h3
            class="font-weight-500 delete-text"
            style="font-size: 20px !important"
          >
            Are you sure you want to delete
            <span class="font-weight-700">{{ dbInvoice?.barcode }}</span>
            ?
          </h3>
        </template>
        <template v-slot:action>
          <v-btn
            depressed
            :disabled="deleteInvoiceLoading"
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="deleteInvoiceDialog = false"
            >No! Cancel</v-btn
          >
          <v-btn
            depressed
            :disabled="deleteInvoiceLoading"
            :loading="deleteInvoiceLoading"
            color="red lighten-1 white--text"
            v-on:click="deleteInvoiceConfirm()"
            class="mx-2 custom-grey-border custom-bold-button"
            >Yes! Delete</v-btn
          >
        </template>
      </DeleteDialog>
      <send-mail
        :mail-dialog="mailDialog"
        title="Send as Email"
        type="user"
        v-on:close="mailDialog = false"
        :type-id="invoiceId"
        v-on:success="getInvoice()"
      ></send-mail>
    </template>
  </ListingTemplate>
  <!--end::User Listing-->
</template>

<script>
import draggable from "vuedraggable";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  SET_VIEW_LINE_ITEM,
  SET_VIEW_CALCULATION,
} from "@/core/services/store/line.item.module";
import { PATCH, POST, GET } from "@/core/services/store/request.module";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import KTOffcanvas from "@/assets/js/components/offcanvas.js";
import JwtService from "@/core/services/jwt.service";
import SendMail from "@/view/pages/partials/Send-Mail";
import DeleteDialog from "@/view/pages/partials/Delete";
export default {
  mixins: [CommonMixin, ListingMixin],
  name: "user-list",
  data() {
    return {
      exportLoading: false,
      mailDialog: false,
      invoiceId: 0,
      deleteInvoiceDialog: false,
      pageModule: "user-listing",
      routeAPI: "user",
      routeName: "user",
      routeDetailName: "user.detail",
      status: "all",
      file: "",
      importDialog: false,
      customThead: [],
      statusList: [],
      deleteInvoiceLoading: false,
      moreActions: [
        /*{
          title: "Import User(s)",
          action: "import_items",
          divider: true,
          icon: "mdi-database-import",
        },
        {
          title: "Export User(s)",
          action: "export_items",
          divider: false,
          icon: "mdi-database-export",
        },*/
        /*{
          title: "Export Current View",
          action: "export_current_view",
          divider: true,
          icon: "mdi-database-export",
        },*/
        {
          title: "Refresh List",
          action: "refresh_list",
          divider: true,
          icon: "mdi-refresh",
        },
      ],
      userMoreAction: [
        {
          title: "Mark as Active",
          icon: "mdi-check-all",
          action: "active",
        },
        {
          title: "Mark as In-Active",
          icon: "mdi-check-all",
          action: "inactive",
        },
      ],
    };
  },
  components: {
    draggable,
    TableActivity,
    ListingTemplate,
    ListingFooter,
    ListingTable,
    ListingHeader,
    ListingSearchCriteria,
    "send-mail": SendMail,
    DeleteDialog,
  },
  methods: {
    getFullName(fullName) {
      if (!fullName) {
        return "";
      }

      return String(fullName)
        .split(/\s+/)
        .filter((name) => name.toLowerCase() !== "none")
        .join(" ");
    },
    getProfileImage(profile_logo) {
      if (profile_logo && profile_logo.file && profile_logo.file.url) {
        return profile_logo.file.url;
      }
      return null;
    },
    getBillingAddress(billing) {
      let billingArray = new Array();
      if (this.lodash.isEmpty(billing) === false) {
        if (billing.unit_no) {
          billingArray.push(billing.unit_no);
        }
        if (billing.street_1) {
          billingArray.push(billing.street_1);
        }
        if (billing.street_2) {
          billingArray.push(billing.street_2);
        }
        if (billing.zip_code) {
          billingArray.push(billing.zip_code);
        }
      }
      return billingArray.join(", ");
    },
    exportQuotation() {
      //console.log(row,"rowhhh");
      //console.log(this.searchableArray,"searchableArray");

      let downloadURL = process.env.VUE_APP_API_URL + "user/export";
      downloadURL = new URL(downloadURL);
      const token = JwtService.getToken();
      downloadURL.searchParams.append("token", token);
      //downloadURL.searchParams.append("search", this.queryParams.search);
      this.lodash.map(this.queryParams, function (row, index) {
        downloadURL.searchParams.append(index, row);
      });

      this.lodash.map(this.listingSearch, function (row, index) {
        // console.log(index, "indexdd")

        if (index == "dates") {
          if (row && row[0]) {
            downloadURL.searchParams.append("dates[0]", row[0]);
          }
          if (row && row[1]) {
            downloadURL.searchParams.append("dates[1]", row[1]);
          }
        } else {
          downloadURL.searchParams.append(index, row);
        }

        //  downloadURL.searchParams.append(index, row);
      });
      window.open(downloadURL, "_blank");
    },
    moreAction(action) {
      const _this = this;
      switch (action) {
        case "import_items":
          _this.importDialog = true;
          break;
        case "export_items":
          _this.bulkUserExport();
          break;
        case "export_current_view":
          break;
        case "refresh_list":
          _this.getRows();
          break;
      }
    },
    getInvoice() {
      this.$store
        .dispatch(GET, { url: "invoice-v1/" + this.invoiceId })
        .then(({ data }) => {
          this.dbInvoice = data;

          this.$store.dispatch(SET_VIEW_CALCULATION, {
            ctx_discount_label: this.dbInvoice?.ctx_discount_label ?? null,
            ctx_discount_value: this.dbInvoice?.ctx_discount_value ?? 0,
            ctx_discount: this.dbInvoice?.ctx_discount ?? 0,
            ctx_discount_type: this.dbInvoice?.ctx_discount_type ?? 1,
            sub_total: this.dbInvoice?.sub_total ?? 1,
            discount_type: this.dbInvoice?.discount_type ?? 1,
            discount_value: this.dbInvoice?.discount_value ?? 0,
            discount_amount: this.dbInvoice?.discount_amount ?? 0,
            tax_active: this.dbInvoice?.tax_active ?? false,
            tax_value: this.dbInvoice?.tax_value ?? 0,
            tax_amount: this.dbInvoice?.tax_amount ?? 0,
            adjustment: this.dbInvoice?.adjustment ?? 0,
            total: this.dbInvoice?.total ?? 0,
            show_price: true,
            discount_level: this.dbInvoice?.discount_level ?? "transaction",
          });

          this.$store.dispatch(SET_VIEW_LINE_ITEM, data.line_item);
          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Invoice", route: "invoice" },
            { title: "Detail" },
            { title: data.barcode },
          ]);
          this.detail_key = Number(new Date());
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.pageLoaded = true;
          this.pageLoading = false;
        });
    },
    /* activeUser(data){
     console.log(data)
    }, */
    updateMoreAction(param) {
      const _this = this;
      switch (param) {
        case "active":
          _this.bulkUserUpdate({
            users: _this.selectedRows,
            status: 1,
          });
          break;
        case "inactive":
          _this.bulkUserUpdate({
            users: _this.selectedRows,
            status: 0,
          });
          break;
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    importRows() {
      // const _this = this;
      const file = this.$refs.file.files[0];
      if (!file) {
        alert("No file chosen");
        return;
      }
      const data = new FormData();
      data.append("excel", file);
      const _this = this;
      _this.$store
        .dispatch(POST, {
          url: "user/import",
          data: data,
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.selectedRows = [];
          _this.getRows();
          _this.importDialog = false;
        });
    },
    bulkUserUpdate(requestObject) {
      const _this = this;
      _this.$store
        .dispatch(PATCH, {
          url: "user/status",
          data: requestObject,
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.selectedRows = [];
          _this.getRows();
        });
    },
    activeInactive(data) {
      const _this = this;
      if (data.activated == false) {
        data.activated = 0;
      } else {
        data.activated = 1;
      }
      _this.$store
        .dispatch(PATCH, {
          url: `single-user/${data.activated}/${data.id}`,
          data: {
            id: data.id,
            status: data.activated,
          },
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.getRows();
        });
    },
  },
  mounted() {
    new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "User",
      },
    ]);
  },
  beforeMount() {
    const _this = this;
    _this.lodash.assign(_this.queryParams, _this.$route.query);

    // _this.defaultColDefs = [
    //   {
    //     headerName: "",
    //     field: "id",
    //     sort: null,
    //     visible: true,
    //     fixed: true,
    //     sortable: false,
    //     checkbox: true,
    //     order: 1,
    //   },
    //   {
    //     headerName: "Image",
    //     field: "image",
    //     sort: null,
    //     image: true,
    //     visible: true,
    //     fixed: false,
    //     sortable: false,
    //     order: 2,
    //   },
    //   {
    //     headerName: "User Info",
    //     field: "user_name",
    //     sort: null,
    //     visible: true,
    //     fixed: false,
    //     sortable: false,
    //     order: 4,
    //   },
    //   {
    //     headerName: "Role",
    //     field: "role",
    //     sort: null,
    //     visible: true,
    //     fixed: false,
    //     sortable: false,
    //     order: 5,
    //   },
    //   {
    //     headerName: "Created Time",
    //     child: "created_at",
    //     field: "added_at",
    //     sort: null,
    //     visible: true,
    //     fixed: false,
    //     sortable: false,
    //     order: 6,
    //   },
    //   {
    //     headerName: "Last Modified Time",
    //     child: "modified_at",
    //     field: "updated_at",
    //     sort: null,
    //     visible: false,
    //     fixed: false,
    //     sortable: false,
    //     order: 7,
    //   },
    // ];

    // const defaultColDefs = _this.lodash.filter(_this.defaultColDefs, {
    //   visible: true,
    // });

    // _this.defaultColShow = defaultColDefs.map((col) => col.field);

    _this.status = _this.$route.query.status || _this.status;

    // _this.applyColState();

    _this.paginationPageSize =
      window.localStorage.getItem(_this.pageModule) || 50;
  },
};
</script>
<style scoped>
.v-menu__content.theme--light.menuable__content__active.custom-menu-list {
  min-width: 221px !important;
  width: 100px;
  top: 44px;
  left: 1520px !important;
  transform-origin: left top;
  z-index: 8;
}
</style>
